module.exports = __webpack_public_path__ + "static/sompo-8eb75d7d26acd325c46d159e1e9dd8c9.png";